import { ChannelMessaging } from '@utilities/ChannelMessaging/ChannelMessaging';
import {
	AuthTokenEventData,
	BuilderConfigEventData,
	ChatMessagePayloadMap,
	ChatMessageType,
	ChatUnreadPayload,
	NotificationEventData
} from '@components/Chat/ChatChannel/ChatChannelType';

/**
 * ChatChannel provides sendConfig, sendAuthToken and chatCount methods.
 **/
export class ChatChannel extends ChannelMessaging<ChatMessagePayloadMap> {
	constructor(port: MessagePort) {
		super(port);
	}

	/** Send builder configuration to the host */
	public sendBuilderConfig({ version, payload }: BuilderConfigEventData): void {
		this.sendMessage(ChatMessageType.CHAT_CONFIGURATION_SET, version, payload);
	}

	/** Listen for unread chat count updates and playSound */
	public onChatCount(callback: (payload: ChatUnreadPayload, version: number) => void): () => void {
		return this.receiveMessage(ChatMessageType.CHAT_UNREAD_SET, (payload, version) =>
			callback(payload, version),
		);
	}

	/** Send authentication token to the host */
	public sendAuthToken({ version, payload }: AuthTokenEventData): void {
		this.sendMessage(ChatMessageType.CHAT_AUTHENTICATION_SET, version, payload);
	}

	/** Send FCM token to the host */
	public sendNotificationToken({ version, payload }: NotificationEventData): void {
		this.sendMessage(ChatMessageType.CHAT_NOTIFICATION_SET, version, payload);
	}
}
